import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";

type FAQItem = {
  question: string;
  answer: string;
};

const faqItems: FAQItem[] = [
  {
    question: "What do I get for free when I sign up?",
    answer:
      "New users get 10 free short videos (~7 seconds each) with no payment required. It's a great way to try our platform before committing to a paid plan. Upgrade anytime to unlock full-length videos and additional features.",
  },
  {
    question: "How does the AI video generation work?",
    answer:
      "Simply upload an image of your product, select an AI actor, customize your script, and generate your video in minutes. Our technology creates natural-looking UGC videos with AI actors that can speak 32+ languages.",
  },
  {
    question: "Can I cancel my subscription anytime?",
    answer:
      "Yes, you can cancel your subscription at any time. There are no long-term contracts or cancellation fees. You'll have access until the end of your current billing period.",
  },
  {
    question: "What's the difference between free and paid videos?",
    answer:
      "Free videos are limited to approximately 7 seconds in length. Paid plans unlock full-length videos (up to 90 seconds), product holding capabilities, custom backgrounds, voice emotion control, and much more.",
  },
];

// Simple ChevronDown icon component
const ChevronDownIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 9l-7 7-7-7"
    />
  </svg>
);

export default function FAQSection() {
  return (
    <section id="faq" className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            Everything you need to know about our AI UGC platform
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <Disclosure
              key={index}
              as="div"
              className="bg-white rounded-lg border border-gray-200 overflow-hidden hover:cursor-pointer"
            >
              {({ open }) => (
                <>
                  <DisclosureButton className="w-full px-5 py-4 text-left flex justify-between items-center focus:outline-none focus-visible:ring focus-visible:ring-blue-500 focus-visible:ring-opacity-50 hover:cursor-pointer">
                    <span className="text-base font-medium text-slate-800">
                      {item.question}
                    </span>
                    <ChevronDownIcon
                      className={`w-5 h-5 text-blue-500 transition-transform duration-200 ${
                        open ? "transform rotate-180" : ""
                      }`}
                    />
                  </DisclosureButton>
                  <div className="overflow-hidden transition-all duration-200 ease-in-out hover:cursor-default">
                    <DisclosurePanel
                      transition
                      className="px-5 pb-4 pt-1 text-sm text-slate-600 origin-top transition-[max-height,opacity,transform] duration-200 ease-out data-[closed]:max-h-0 data-[closed]:opacity-0 data-[closed]:-translate-y-2 hover:cursor-text"
                    >
                      {item.answer}
                    </DisclosurePanel>
                  </div>
                </>
              )}
            </Disclosure>
          ))}
        </div>
      </div>
    </section>
  );
}
